<template>
    <div class="modal fade wallmodal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog">
            <div class="modal-content b-light">
                <div class="modal-body">
                    <div class="wall" v-if="wall">
                        <div class="d-flex justify-content-between wall-header" :class="statusClass">
                            <div class="wall-status d-flex justify-content-center">
                                <div class="pt-1 mr-3 pointer btn-clear" @click="clear()" v-if="wall.user_id === $store.state?.user?.id">
                                    <i class="fas fa-trash"></i>
                                </div>
                                <div class="dropdown pointer pt-1 mr-3">
                                    <span v-if="wall.rating_id" data-toggle="dropdown">
                                        {{wall.rating.rating_name}}
                                    </span>
                                    <span v-else data-toggle="dropdown">
                                        全年齢
                                    </span>
                                    <div class="dropdown-menu" v-if="isAdmin">
                                        <a href="#" class="dropdown-item" @click.prevent="changeRating()">全年齢</a>
                                        <a href="#" class="dropdown-item" @click.prevent="changeRating('R15')">R15</a>
                                        <a href="#" class="dropdown-item" @click.prevent="changeRating('R18')">R18</a>
                                        <a href="#" class="dropdown-item" @click.prevent="changeRating('XXX')">XXX</a>
                                    </div>
                                </div>
                                <div class="pt-1">
                                    <span class="badge badge-primary" v-if="$isPortal">
                                        {{visitors}} 人視聴
                                    </span>
                                </div>
                            </div>
                            <a href="#" class="float-right xmark" data-dismiss="modal" aria-label="Close">
                                <i class="fas fa-times"></i>
                            </a>
                        </div>
                        <div class="wall-posts" id="wall-post" :class="{'transparent': !show}">
                            <div id="wall-post-list" v-if="posts.length > 0">
                                <div class="wall-post-outline" :class="{'isolate': isChanged(i)}" v-for="(p, i) in posts" :key="i">
                                    <div class="wall-post">
                                        <div class="wall-post-name d-flex justify-content-between flex-nowrap"
                                            v-if="i === 0 || isChanged(i)"
                                            :class="{'flex-row-reverse': wall.user_id !== p.wall_user.user_id}">
                                            <div v-if="p.wall_user" class="d-flex justify-content-between">
                                                <div class="pt-1 mr-1" v-if="!p.wall_user.is_allowed">
                                                    <span v-if="wall.user_id === $store.state?.user?.id"
                                                        class="btn badge badge-success badge-pill" @click="allowUser(p.wall_user.id)">
                                                        <i class="fas fa-check"></i>
                                                        承認
                                                    </span>
                                                    <span v-else class="badge badge-secondary">
                                                        承認待ち
                                                    </span>
                                                </div>
                                                <div v-if="p.wall_user?.user?.profile_url" class="mr-1">
                                                    <img :src="p.wall_user.user.profile_url" class="user-icon">
                                                </div>
                                                <div class="d-inline-block pt-1">
                                                    {{ p.wall_user.user_name }}
                                                </div>
                                                <div class="pt-1 ml-1" v-if="wall.user_id === $store.state?.user?.id && wall.user_id !== p.wall_user.user_id">
                                                    <span class="pointer text-danger"
                                                        @click="banUser(p.wall_user)">
                                                        <i class="fas fa-ban"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="small">
                                                <div class="wall-timestamp nowrap">
                                                    {{$filters.dateFormat(p.created_at, 'YYYY/MM/DD HH:mm')}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between hide-time position-relative">
                                            <div v-if="canVisible(p)"
                                                :class="{'not-allowed': !p.wall_user.is_allowed}"
                                                v-html="$filters.url(p.body)"></div>
                                            <div v-else>承認待ちです。</div>
                                            <div class="d-flex justify-content-end">
                                                <div class="favorite nowrap text-danger" @click="favorite(p)">
                                                    <heart :likes="p.favorite"></heart>
                                                    <span v-if="p.favorite">{{p.favorite}}</span>
                                                </div>
                                            </div>
                                            <div class="time-post b-light small nowrap">
                                                {{$filters.dateFormat(p.created_at, 'HH時mm分')}}
                                            </div>
                                        </div>
                                        <div class="wall-image d-flex justify-content-center pointer" v-if="p.image_url || p.image">
                                            <img :src="p.image_url" class="img-fluid img-thumbnail img-post" v-if="p.image_url" @click="showImage(p.image_url)">
                                            <img :src="p.image" class="img-fluid img-thumbnail img-post" v-else @click="showImage(p.image)">
                                        </div>
                                    </div>
                                    <div v-if="p.id && canOgp(p.hash) && getUrl(p.body)" class="m-2">
                                        <ogp-pane :url="getUrl(p.body)"></ogp-pane>
                                    </div>
                                </div>
                            </div>
                            <div class="wall-post-empty" v-else>
                                <div v-if="wall.user_id === $store.state?.user?.id">
                                    <p>
                                        壁打ちは、執筆中に浮かんでくるアイデアや雑念、愚痴、自慢、
                                        その他のどうでもいいことなどを垂れ流す場所です。
                                    </p>
                                    <p>
                                        壁打ちを開始すると、あなたの本棚に壁打ちの投稿がリアルタイムに流れます。
                                    </p>
                                    <p>
                                        読者からメッセージを受け取った場合、その読者を承認するまでメッセージは公開されません。
                                    </p>
                                </div>
                                <div v-else>
                                    <p>
                                        壁打ちは作者様のつぶやきがリアルタイムに流れてくる場所です。
                                    </p>
                                    <p>
                                        投稿が１件以上あるときに限り、作者様にメッセージを送信することができます。
                                    </p>
                                    <p>
                                        メッセージは作者様が承認するまで表示されません。
                                    </p>
                                </div>
                                <div class="d-flex justify-content-center mt-5">
                                    <i class="fas fa-table-tennis fa-big"></i>
                                </div>
                            </div>
                        </div>
                        <div class="wall-input">
                            <div class="preview d-flex justify-content-center" v-if="post.image_url">
                                <img :src="post.image_url" class="img-fluid img-thumbnail img-preview">
                                <i class="far fa-times-circle img-clear" @click="clearImage()"></i>
                            </div>
                            <div class="input-group">
                                <div class="input-group-prepend" v-if="wall.user_id === $store.state?.user?.id">
                                    <label class="btn btn-warning mb-0">
                                        <i class="far fa-image"></i>
                                        <input type="file" ref="image" @change="changeImage()" accept="image/*" class="d-none">
                                    </label>
                                </div>
                                <input type="text" class="form-control shadow-none"
                                    :class="{'top-left-no-radius': wall.user_id !== $store.state?.user?.id}"
                                    placeholder="投稿内容"
                                    ref="body"
                                    :disabled="!isAdmin && this.posts.length === 0"
                                    maxlength="500"
                                    @keydown.enter="send($event)" v-model="post.body">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" @click="send()" :disabled="!isAdmin && this.posts.length === 0">
                                        <i class="fas fa-paper-plane"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-easy-lightbox :imgs="imgs" :visible="showLightbox" @hide="hideImage()"></vue-easy-lightbox>
    </div>
</template>

<style scoped lang="scss">
$width: 320px;
$height: min(100svh, 680px);
.wallmodal {
    .modal-dialog {
        position: fixed;
        margin: auto;
        width: $width;
        height: $height;
        bottom: 15px;
        transform: translate3d(0%, 0, 0);
        .modal-content {
            height: $height;
            border: 0;
            position: relative;
            overflow: hidden;
        }
    }
    &.fade {
        .modal-dialog {
            right: -$width;
            transition: opacity 0.2s linear, right 0.2s ease-out;
            .modal-body {
                padding: 0;
            }
        }
        &.show .modal-dialog {
            right: 15px;
        }
    }
}
.wall {
    overflow: hidden;
    .wall-icon {
        padding: 1rem 10rem;
    }
    .xmark {
        font-size: 1.7rem;
        margin-right: 0.8rem;
    }
    .wall-header {
        position: sticky;
        top: 0;
        z-index: 99;
    }
    .wall-title {
        text-align: center;
        margin: 1rem 0;
        letter-spacing: 2px;
    }
    .wall-description {
        margin: 3rem;
        padding: 1rem;
        background-color: #436481;
        color: snow;
        border-radius: .5rem;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -15px;
            border: 15px solid transparent;
            border-top: 15px solid #436481;
        }
    }
    .wall-beta {
        margin: 3rem;
        padding: 1rem;
        border: 1px solid #999;
        border-radius: .5rem;
    }
    .wall-input {
        position: fixed;
        bottom: 0;
        width: 100%;
        .preview {
            width: 100%;
            margin-bottom: .5rem;
            .img-preview {
                max-height: 360px;
            }
            .img-clear {
                font-size: 2.5rem;
                margin-top: .5rem ;
                margin-left: -3rem;
                cursor: pointer;
            }
        }
        .btn {
            border-radius: 0;
        }
        .form-control {
            height: calc(1.8em + 0.9rem);
        }
    }
    .wall-name {
        max-width: $width;
    }
    .wall-status {
        padding: .3rem .8rem;
        text-align: center;
        font-weight: bold;
        font-size: 1.1rem;
    }
    .wall-list {
        overflow-x: auto;
        overflow-y: hidden;
        display: flex;
        flex-wrap: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
        .btn {
            flex-shrink: 0;
        }
    }
    .wall-posts {
        margin: 0;
        padding: 1rem 0;
        height: calc($height - 90px);
        overflow: scroll;
        position: relative;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar{
            display:none;
        }
        .wall-post-outline {
            &.isolate {
                margin-top: 0.8rem;
                padding-top: 0.8rem;
                border-top: 1px solid #ddd;
            }
            .wall-post {
                padding: 0 0.8rem;
                margin: 0;
                font-size: 0.8rem;
                .wall-post-name {
                    font-weight: bold;
                    font-size: .75rem;
                    margin-bottom: .25rem;
                    .user-icon {
                        width: 32px;
                        height: 32px;
                        display: inline-block;
                        border-radius: 50%;
                    }
                }
                .wall-image {
                    margin: .7rem 0;
                    .img-post {
                        border-radius: .7rem;
                    }
                }
                .wall-timestamp {
                    display: inline-block;
                    padding: .4rem 0;
                    vertical-align: middle;
                    font-size: .65rem;
                }
                .hide-time {
                    .time-post {
                        position: absolute;
                        right: 1.8rem;
                        top: 0;
                        padding: .25rem;
                        border-radius: .25rem;
                        visibility: hidden;
                    }
                    &:hover {
                        .time-post {
                            position: absolute;
                            right: 1.8rem;
                            top: 0;
                            padding: .25rem;
                            border-radius: .25rem;
                            visibility: visible;
                        }
                    }
                }
                .favorite {
                    display: inline-block;
                    font-size: 0.7rem;
                }
            }
        }
        .wall-post-empty {
            padding: 0 0.8rem;
        }
    }
}
.input-group-prepend {
    border-radius: 0 0 0 .25rem;
    overflow: hidden;
}
.input-group-append {
    border-radius: 0 0 .25rem 0;
    overflow: hidden;
}
.btn-clear {
    &:hover {
        opacity: .8;
    }
}
.not-allowed {
    opacity: .5;
}
.top-left-no-radius {
    border-top-left-radius: 0;
}
.fa-big {
    font-size: 5rem;
}
.transparent {
    opacity: 0;
}
@media screen and (max-width: 770px) {
    .wallmodal {
        .modal-dialog {
            position: fixed;
            margin: auto;
            width: 100vw;
            height: 100svh;
            bottom: 0;
            transform: translate3d(0%, 0, 0);
            .modal-content {
                height: 100svh;
                border: 0;
                position: relative;
                overflow: hidden;
            }
        }
        &.fade {
            .modal-dialog {
                right: -100vw;
                transition: opacity 0.2s linear, right 0.2s ease-out;
                .modal-body {
                    padding: 0;
                }
            }
            &.show .modal-dialog {
                right: 0;
            }
        }
    }
    .wall {
        .wall-posts {
            height: calc(100svh - 90px);
        }
    }
}
</style>

<script>
import heart from "components/Heart";
import ogpPane from "components/Ogp";
export default {
    components: {
        heart,
        ogpPane,
    },
    emits: [
        "ready",
        "stop",
        "unread",
        "rateWall",
    ],
    props: {
        id: {
            default: "wall-modal"
        },
        updated_id: {
            default: null,
        }
    },
    data() {
        return {
            wall: null,
            post: {
                body: "",
                image: null,
                image_url: null,
            },
            posts: [],
            showLightbox: false,
            imgs: [],
            user_hash: null,
            visitors: 0,
            wall_user: null,
            isOpened: false,
            timer: null,
            nextTrigger: null,
            LOTATION: 256,
            MAX_OGP: 5,
            recentTimer: null,
            last_id: null,      // 最後に読み込んだID
            show: false,
        }
    },
    methods: {
        load(onlyWall = false) {
            axios.get("/author/wall/get").then(res => {
                if (res.data.wall) {
                    this.wall = res.data.wall;
                    if (!this.isAdmin && this.wall.rating) {
                        if (this.$store.state?.user) {
                            if (this.$store.state.user.rating_id < this.wall.rating.id) {
                                $("#" + this.id).modal("hide");
                            }
                        } else if (this.wall.rating.id > 1 && !this.$store.state.r18) {
                            $("#" + this.id).modal("hide");
                        }
                    }
                    this.$emit("rateWall", this.wall.rating);
                    if (!onlyWall) {
                        this.loadPosts();
                        this.connectWall();
                    }
                    if (res.data.wall_user && !res.data.wall_user.is_banned) {
                        this.$emit("ready");
                    }
                } else {
                    const obj = this;
                    this.$observer.observe("login", obj.load.bind(obj));
                }
                this.wall_user = res.data.wall_user;
            }).catch(err => { alert.err(err) });
        },
        loadPosts() {
            if (this.oldestPostId && this.oldestPostId === this.last_id) return;
            this.last_id = this.oldestPostId;
            axios.get("/author/wall/posts", {params: {
                id: this.wall.id,
                oldest_post_id: this.oldestPostId,
            }}).then(res => {
                if (res.data) {
                    const org_height = $("#wall-post")[0].scrollHeight;
                    for (const post of res.data) {
                        this.unshiftToWall(post);
                    }
                    setTimeout(() => {
                        const new_height = $("#wall-post")[0].scrollHeight;
                        $("#wall-post")[0].scrollTop = new_height - org_height;
                    });
                }
            }).catch(err => { alert.err(err) });
        },
        unshiftToWall(post) {
            const index = _.findIndex(this.posts, {hash: post.hash})
            if (index > -1) {
                this.posts[index] = post;
            } else {
                this.posts.unshift(post);
                this.setRecentHash();
            }
        },
        pushToWall(post, noScroll = false) {
            const index = _.findIndex(this.posts, {hash: post.hash})
            if (index > -1) {
                this.posts[index] = post;
            } else {
                this.posts.push(post);
                this.setRecentHash();
            }
            if (!noScroll) {
                setTimeout(() => {
                    this.scrollBottom();
                });
            }
        },
        send(ev = null) {
            if (ev && (ev.isComposing || ev.keyCode !== 13)) { return; }
            if (this.post.body === "") { return; }
            // 送信データ生成
            Object.assign(this.post, this.postTemplate());
            this.post.wall_user.user = this.$store.state?.user || null;
            if (!this.post.image) {
                this.pushToWall(this.post);
            }
            if (!this.isCommand(this.post)) {
                const fd = new FormData();
                fd.append('image', this.post.image);
                fd.append('image_url', this.post.image_url);
                fd.append('body', this.post.body);
                fd.append('hash', this.post.hash);
                axios.post("/author/wall/post", fd).then(res => {
                    this.wall_user = res.data;
                }).catch(err => { alert.err(err.response) });
            }
            this.post = { body: "", image: null, image_url: null };
            setTimeout(() => { try { this.$refs.body.focus() } catch (error) {} });
        },
        clearImage() {
            this.post.image = null;
            this.post.image_url = null;
        },
        changeImage() {
            if (this.$refs.image.files[0].size > 5000 * 1024) {
                alert.err("ファイルサイズが大きすぎます: " + this.$refs.image.files[0].size);
                return;
            }
            this.post.image = this.$refs.image.files[0];
            this.post.image_url = URL.createObjectURL(this.post.image);
            setTimeout(() => {this.$refs.body.focus()});
        },
        changeRating(rating = null) {
            axios.post("/mypage/wall/rating", {
                rating_name: rating
            }).catch(err => { alert.err(err) });
        },
        clear() {
            Swal.fire({
                title: "投稿クリア",
                html: `全ての投稿を削除します。
                <div class="small text-danger text-left">
                    読者の投稿も含めてすべて削除します。
                    投稿者の承認情報もクリアします。<br>
                    そのまま投稿を続けても古いものから消えていきます。
                </div>`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "投稿クリア",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/wall/clear").then(res => {
                        this.posts = [];
                        this.load();
                    }).catch(err => { alert.err(err) });
                }
            });
        },
        connectWall() {
            Echo.channel("wall." + this.wall.id).listen("Wall\\Posted", (e) => {
                // 投稿
                this.pushToWall(e.post);
            }).listen("Wall\\Allowed", (e) => {
                // 承認
                for (const i in this.posts) {
                    if (this.posts[i].wall_user.id === e.wall_user_id) {
                        this.posts[i].wall_user.is_allowed = 1;
                    }
                }
            }).listen("Wall\\Banned", (e) => {
                // BAN
                if (e.wall_user_id === this.wall_user.id) {
                    $("#" + this.id).modal("hide");
                    this.$emit("stop");
                }
                this.posts = _.filter(this.posts, (o) => { return o.wall_user_id !== e.wall_user_id; });
            }).listen("Wall\\Restore", (e) => {
                // BAN解除
                if (e.wall_user_id === this.wall_user.id) {
                    this.$emit("ready");
                }
            }).listen("Wall\\Favorite", (e) => {
                // いいね
                const p = _.find(this.posts, {hash: e.post.hash});
                p.favorite = e.post.favorite;
            }).listen("Wall\\Changed", (e) => {
                // レーティング、名前変更
                this.load(true);
            }).listen("Wall\\Clear", (e) => {
                // 投稿クリア
                this.posts = [];
            }).listen("Wall\\ChangeVisitors", (e) => {
                // 視聴者数変更
                this.visitors = e.visitors;
            });
            this.heartbeat();
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                if (this.nextTrigger && Date.now() > this.nextTrigger) {
                    this.heartbeat();
                }
            }, 60 * 1000);
        },
        leaveWall() {
            const csrf = $("meta[name='csrf-token']").attr("content");
            const payload = new FormData();
            payload.append("_token", csrf);
            navigator.sendBeacon("/author/wall/leave", payload);
            if (this.wall) {
                Echo.leaveChannel("wall." + this.wall.id);
            }
        },
        heartbeat() {
            axios.post("/author/wall/heartbeat", {
                visitors: this.visitors
            }).then(res => {
                this.nextTrigger = Date.now() + (5 * 60 * 1000);
            }).catch(err => { alert.err(err) });;
        },
        isChanged(i) {
            if (i === 0) {
                return false;
            }
            const prev = this.posts[i - 1];
            const curr = this.posts[i];
            if (moment(prev.created_at).format("YYMMDD H") !== moment(curr.created_at).format("YYMMDD H")) {
                return true;
            }
            if (curr.wall_user_id) {
                if (prev.wall_user_id !== curr.wall_user_id) return true;
                if (prev.wall_user.user_name !== curr.wall_user.user_name) return true;
            }
            return false;
        },
        ratingClass(rating) {
            const cls = {};
            if (rating) {
                cls["badge-" + rating.color] = true;
            }
            return cls;
        },
        scrollBottom(is_animate = true) {
            try {
                const top = $("#wall-post-list")[0]?.clientHeight;
                if (is_animate) {
                    $("#wall-post").animate({scrollTop: top}, 300);
                } else {
                    $("#wall-post").scrollTop(top);
                }
                setTimeout(() => this.show = true);
            } catch (error) {
                console.error(error);
                this.show = true
            }
        },
        showImage(src) {
            this.imgs = [];
            this.imgs.push(src);
            this.showLightbox = true;
        },
        hideImage() {
            this.showLightbox = false;
            this.img = [];
        },
        // 承認
        allowUser(id) {
            axios.post("/mypage/wall/allow", {id: id}).then(res => {
            }).catch(err => { alert.err(err) });
        },
        // BAN
        banUser(user) {
            Swal.fire({
                title: "排除",
                html: `<b>${user.user_name}</b> さんを壁打ちから排除します。
                <div class="small text-primary text-left">
                    一度排除すると元に戻すことはできませんが、
                    壁をクリアすることで初期状態に戻すことができます。
                </div>
                <div class="small text-danger text-left">
                    排除されたユーザーは即座に壁打ちウインドウが閉じ、
                    再び開くことができなくなります。
                </div>
                `,
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "排除",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/wall/ban", {id: user.id}).then(res => {
                        const reply = this.postTemplate();
                        const post = [];
                        post.push(`${user.user_name} さんを排除しました。`);
                        post.push(`もとに戻す場合は /banned と入力して排除リストを表示してください。`);
                        reply.body = post.join("\n");
                        this.pushToWall(reply);
                    }).catch(err => { alert.err(err) });
                }
            });
        },
        isAllowable(post) {
            if (this.wall.user_id === this.$store.state?.user?.id && !post.wall_user.is_allowed) {
                return true;
            }
            return  false;
        },
        canVisible(post) {
            if (this.wall.user_id == this.$store.state?.user?.id || post.wall_user.is_allowed) {
                // 管理者が閲覧しているか、承認済みユーザーの書き込み
                return true;
            }
            if (post.wall_user.user_hash === this.wall_user?.user_hash) {
                // 自分自身の書き込み
                return true;
            }
            return false;
        },
        favorite(p) {
            axios.post("/author/wall/favorite", {id: p.id}).catch(err => { alert.err(err) });
        },
        isCommand(post) {
            if (post.body.match(/^\/[a-z]+/)) {
                const reply = this.postTemplate();
                if (this.isAdmin && post.body.match(/^\/banned/)) {
                    // BAN一覧
                    axios.get("/mypage/wall/banned").then(res => {
                        if (res.data.length) {
                            const list = [];
                            list.push(`排除されたユーザーは以下のとおりです。`);
                            for (const banned of res.data) {
                                list.push(`${banned.id}: ${banned.user_name}`)
                            }
                            list.push(`復帰する場合は /restore {id} と入力してください。`);
                            reply.body = list.join("\n");
                        } else {
                            reply.body = `排除されたユーザーはいません。`;
                        }
                        this.pushToWall(reply);
                    }).catch(err => { alert.err(err) });
                } else if (this.isAdmin && post.body.match(/^\/restore \d+/)) {
                    // BANユーザーを復帰
                    const matched = post.body.match(/^\/restore (\d+)/);
                    axios.post("/mypage/wall/restore", {id: matched[1]}).then(res => {
                        reply.body = `ユーザーID: ${matched[1]} を復帰しました。`;
                        this.pushToWall(reply);
                    }).catch(err => { alert.err(err) });
                } else if (post.body.match(/^\/rename .+/)) {
                    // 名前変更
                    const matched = post.body.match(/^\/rename (.+)/);
                    axios.post("/author/wall/rename", {user_name: matched[1]}).then(res => {
                        if (res.data) {
                            reply.body = `ユーザー名を ${matched[1]} に変更しました。`;
                        } else {
                            reply.body = `ユーザー名の変更に失敗しました。`;
                        }
                        this.pushToWall(reply);
                    }).catch(err => { alert.err(err) });
                } else if (post.body.match(/^\/close/)) {
                    $("#" + this.id).modal("hide");
                } else if (post.body.match(/^\/clear/)) {
                    this.clear();
                } else {
                    // ヘルプ
                    const help = [];
                    help.push("コマンド一覧:");
                    if (this.isAdmin) {
                        help.push("/banned … BANユーザー一覧。");
                        help.push("/restore {id} … BANユーザーを復帰。");
                        help.push("/close … 壁打ちを閉じる。");
                        help.push("/clear … 壁打ちを全削除する。");
                    } else {
                        help.push("/rename {name} … 名前を{name}に変更。");
                    }
                    reply.body = help.join("\n");
                    this.pushToWall(reply);
                }
                return true;
            }
            return false;
        },
        postTemplate() {
            return {
                "hash": Math.random().toString(16).slice(2),
                "updated_at": moment().format("YYYY-MM-DD HH:mm:ss"),
                "created_at": moment().format("YYYY-MM-DD HH:mm:ss"),
                "wall_user_id": this.wall_user.id,
                "wall_user": this.wall_user,
            };
        },
        canOgp(hash) {
            const ogps = _.filter(this.posts, (o) => { return this.getUrl(o.body); });
            const avail = [];
            if (ogps.length > 0) {
                for (let i = 0; i < this.MAX_OGP; i++) {
                    avail.push(ogps.pop());
                    if (ogps.length === 0) break;
                }
            }
            if (_.find(avail, {hash: hash})) {
                return true;
            }
            return false;
        },
        getUrl(body) {
            const matches = body.match(/(https?:\/\/[\w!?\/+\-_~;.,*&@#$%()'[\]]+)/g);
            if (matches) {
                return matches.pop();
            }
            return null;
        },
        /**
         * 最後に読んだIDを保存し、未読数をカウントする。
         */
        setRecentHash() {
            if (this.recentTimer) {
                clearTimeout(this.recentTimer);
            }
            this.recentTimer = setTimeout(() => {
                if (this.isOpened) {
                    // 最新のハッシュを保存して未読を０件にする
                    let recent_hash = null;
                    if (this.posts.length) {
                        recent_hash = _.last(this.posts).hash;
                        if (recent_hash) {
                            this.$cookie.set('recent_hash', recent_hash);
                        }
                    }
                    this.$emit('unread', 0);
                } else {
                    // ハッシュは保存せず未読数を送信する
                    const index = _.findIndex(this.posts, {hash: this.$cookie.get('recent_hash')});
                    let unread = 0;
                    if (this.posts.length) {
                        unread = this.posts.length - (index + 1);
                    }
                    this.$emit('unread', unread);
                }
            }, 150);
        },
        infinityScroll() {
            try {
                if ($("#wall-post")[0].scrollTop == 0) {
                    this.page++;
                    this.loadPosts();
                }
            } catch (error) {
                console.error(error);
            }
        },
    },
    computed: {
        statusClass() {
            const cls = {};
            if (this.wall?.rating_id) {
                cls["bg-" + this.wall.rating.color] = true;
                if (this.wall.rating.color == "warning") {
                    cls["text-dark"] = true;
                } else {
                    cls["text-white"] = true;
                }
            }
            return cls;
        },
        isAdmin() {
            // 壁打ち管理者かどうか
            return this.wall?.user_id === this.$store.state?.user?.id;
        },
        oldestPostId() {
            // 一番古い投稿レコードのID
            if (this.posts.length) {
                return _.find(this.posts, (o) => { return o.id; }).id;
            }
            return null;
        },
    },
    beforeUnmount() {
        this.leaveWall();
    },
    mounted() {
        setTimeout(() => {
            this.load();
        }, 1500);
        $("#" + this.id).on("shown.bs.modal", (e) => {
            this.isOpened = true;
            this.setRecentHash();
            setTimeout(() => {
                this.scrollBottom(false);
                this.$refs.body.focus();
            });
            if (document.getElementById("wall-post")) {
                document.getElementById("wall-post").addEventListener("scroll", this.infinityScroll);
            }
        });
        $("#" + this.id).on("hide.bs.modal", (e) => {
            this.isOpened = false;
            this.show = false;
        });
        this.setRecentHash();
        window.addEventListener("beforeunload", this.leaveWall);
    }
}
</script>